export const categories = [
  { id: "all", name: "全部", icon: "ri-apps-line" },
  { id: "movie", name: "电影", icon: "ri-film-line" },
  { id: "drama", name: "电视剧", icon: "ri-tv-line" },
  { id: "variety", name: "综艺", icon: "ri-live-line" },
  { id: "anime", name: "动漫", icon: "ri-ghost-line" },
  { id: "documentary", name: "纪录片", icon: "ri-slideshow-line" },
];

export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    englishTitle: "The Wandering Earth 3",
    category: "movie",
    genre: "科幻 / 冒险",
    year: 2026,
    rating: 9.2,
    poster: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20giant%20planet%20in%20space%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20dark%20background%20with%20starry%20sky%2C%20professional%20movie%20poster%20art%20style&width=600&height=840&seq=movie-01&orientation=portrait",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代勇敢地站出来，为人类的未来而战。",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健"],
    duration: "148分钟",
    region: "中国大陆",
    isNew: true,
    isHot: true,
    isRecommended: true,
    updateInfo: "更新至HD",
  },
  {
    id: 2,
    title: "封神第二部",
    englishTitle: "Creation of the Gods II",
    category: "movie",
    genre: "奇幻 / 古装",
    year: 2026,
    rating: 9.0,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20mythology%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20golden%20and%20red%20tones%2C%20traditional%20Chinese%20art%20style%2C%20dramatic%20composition&width=600&height=840&seq=movie-02&orientation=portrait",
    description: "商朝末年，纣王暴虐无道。姬发在姜子牙的辅佐下，率领八百诸侯起兵讨伐商纣，一场人、仙、妖之间的大战就此展开。",
    director: "乌尔善",
    cast: ["费翔", "黄渤", "于适"],
    duration: "156分钟",
    region: "中国大陆",
    isNew: true,
    isHot: true,
    isRecommended: false,
    updateInfo: "HD1080P",
  },
  {
    id: 3,
    title: "哪吒之魔童闹海",
    englishTitle: "Nezha: The Devil Child Havoc in the Sea",
    category: "anime",
    genre: "动画 / 奇幻",
    year: 2025,
    rating: 9.5,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20featuring%20a%20mythological%20boy%20with%20flaming%20wheels%20and%20red%20ribbon%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20gold%20colors%2C%20traditional%20Chinese%20painting%20style%20blended%20with%203D%20animation&width=600&height=840&seq=movie-03&orientation=portrait",
    description: "哪吒与敖丙在天劫之后灵魂得以保存，太乙真人用七色宝莲为其重塑肉身，然而东海龙王的复仇之路才刚刚开始。",
    director: "饺子",
    cast: ["吕艳婷", "陈浩", "囧森瑟夫"],
    duration: "144分钟",
    region: "中国大陆",
    isNew: false,
    isHot: true,
    isRecommended: true,
    updateInfo: "4K超清",
  },
  {
    id: 4,
    title: "庆余年第二季",
    englishTitle: "Joy of Life Season 2",
    category: "drama",
    genre: "古装 / 权谋",
    year: 2025,
    rating: 9.3,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20with%20a%20scholar%20in%20ancient%20Chinese%20costume%2C%20ink%20wash%20painting%20style%2C%20elegant%20composition%2C%20warm%20golden%20and%20dark%20tones%2C%20traditional%20Chinese%20aesthetic&width=600&height=840&seq=movie-04&orientation=portrait",
    description: "范闲身世之谜逐渐揭开，他从一个被追杀的少年，成长为能够左右天下局势的关键人物。京都暗流涌动，各方势力蠢蠢欲动。",
    director: "孙皓",
    cast: ["张若昀", "李沁", "陈道明"],
    duration: "45分钟/集",
    region: "中国大陆",
    isNew: false,
    isHot: true,
    isRecommended: true,
    updateInfo: "更新至36集",
  },
  {
    id: 5,
    title: "奔跑吧第八季",
    englishTitle: "Keep Running Season 8",
    category: "variety",
    genre: "真人秀 / 综艺",
    year: 2026,
    rating: 8.8,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20outdoors%2C%20bright%20energetic%20colors%2C%20fun%20and%20dynamic%20composition%2C%20entertainment%20show%20style%2C%20cheerful%20atmosphere&width=600&height=840&seq=movie-05&orientation=portrait",
    description: "全新一季奔跑吧，新老成员齐聚，开启一段充满欢笑与挑战的旅程。每一期都有意想不到的惊喜和感动。",
    director: "姚译添",
    cast: ["李晨", "郑恺", "Angelababy", "白鹿", "周深"],
    duration: "90分钟/期",
    region: "中国大陆",
    isNew: true,
    isHot: true,
    isRecommended: false,
    updateInfo: "更新至2026-07-30期",
  },
  {
    id: 6,
    title: "满江红",
    englishTitle: "Full River Red",
    category: "movie",
    genre: "悬疑 / 历史",
    year: 2025,
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20mystery%20movie%20poster%20with%20ancient%20courtyard%20and%20lanterns%2C%20dark%20red%20and%20black%20tones%2C%20suspenseful%20atmosphere%2C%20traditional%20Chinese%20architecture%2C%20cinematic%20composition&width=600&height=840&seq=movie-06&orientation=portrait",
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，密信不翼而飞。一个小兵与亲兵营副统领被裹挟进巨大阴谋之中。",
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "张译"],
    duration: "159分钟",
    region: "中国大陆",
    isNew: false,
    isHot: false,
    isRecommended: true,
    updateInfo: "HD1080P",
  },
  {
    id: 7,
    title: "三体",
    englishTitle: "Three-Body",
    category: "drama",
    genre: "科幻 / 悬疑",
    year: 2025,
    rating: 9.1,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20mysterious%20cosmic%20elements%20and%20satellite%20dish%2C%20dark%20blue%20and%20black%20tones%2C%20mysterious%20atmosphere%2C%20scientific%20and%20philosophical%20vibe%2C%20minimalist%20design&width=600&height=840&seq=movie-07&orientation=portrait",
    description: "纳米科学家汪淼被警官史强带入一个神秘组织，由此揭开了地球基础科学出现异常扰动背后的惊天秘密。",
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾"],
    duration: "45分钟/集",
    region: "中国大陆",
    isNew: false,
    isHot: true,
    isRecommended: true,
    updateInfo: "全30集",
  },
  {
    id: 8,
    title: "功夫熊猫5",
    englishTitle: "Kung Fu Panda 5",
    category: "anime",
    genre: "动画 / 喜剧",
    year: 2026,
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=Kung%20Fu%20Panda%20animated%20movie%20poster%20with%20panda%20in%20martial%20arts%20pose%2C%20colorful%20Chinese%20style%20background%2C%20dynamic%20action%2C%20warm%20and%20vibrant%20colors%2C%20family%20movie%20poster%20style&width=600&height=840&seq=movie-08&orientation=portrait",
    description: "阿宝再次踏上冒险之旅，这次他将面对一个前所未有的强敌。在师父和朋友们的帮助下，阿宝必须找到真正的内心力量。",
    director: "迈克·米切尔",
    cast: ["黄磊", "成龙", "杨幂"],
    duration: "105分钟",
    region: "美国 / 中国",
    isNew: true,
    isHot: false,
    isRecommended: false,
    updateInfo: "HD",
  },
  {
    id: 9,
    title: "猩球崛起4：新世界",
    englishTitle: "Kingdom of the Planet of the Apes",
    category: "movie",
    genre: "科幻 / 动作",
    year: 2026,
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20movie%20poster%20with%20intelligent%20ape%20in%20ruined%20city%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20dark%20tones%20with%20green%20accents%2C%20Hollywood%20blockbuster%20style&width=600&height=840&seq=movie-09&orientation=portrait",
    description: "在凯撒统治数代之后，猿类成为主导物种，人类则退化到原始状态。一只年轻的猿类开始质疑他所知道的一切，踏上了一场决定未来的旅程。",
    director: "韦斯·鲍尔",
    cast: ["欧文·泰格", "芙蕾雅·艾伦"],
    duration: "145分钟",
    region: "美国",
    isNew: true,
    isHot: true,
    isRecommended: false,
    updateInfo: "HD1080P",
  },
  {
    id: 10,
    title: "乘风破浪的姐姐第五季",
    englishTitle: "Sisters Who Make Waves S5",
    category: "variety",
    genre: "音乐 / 竞演",
    year: 2026,
    rating: 8.9,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20reality%20show%20poster%20with%20group%20of%20elegant%20female%20celebrities%20on%20stage%2C%20glamorous%20lighting%2C%20purple%20and%20gold%20tones%2C%20entertainment%20show%20style%2C%20sophisticated%20aesthetic&width=600&height=840&seq=movie-10&orientation=portrait",
    description: "全新一季姐姐们乘风而来，用实力和魅力征服舞台。她们用音乐诉说故事，用舞蹈展现态度。",
    director: "吴梦知",
    cast: ["宁静", "那英", "王心凌", "薛凯琪"],
    duration: "120分钟/期",
    region: "中国大陆",
    isNew: false,
    isHot: false,
    isRecommended: true,
    updateInfo: "更新至第8期",
  },
  {
    id: 11,
    title: "繁花",
    englishTitle: "Blossoms Shanghai",
    category: "drama",
    genre: "都市 / 商战",
    year: 2024,
    rating: 9.4,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20neon%20lights%20and%20vintage%20cars%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20tones%2C%20elegant%20cinematic%20composition%2C%20Chinese%20TV%20drama%20style&width=600&height=840&seq=movie-11&orientation=portrait",
    description: "九十年代的上海，阿宝凭借自己的智慧和魄力，在商海沉浮中成就了一段传奇。商界风云变幻，人情冷暖自知。",
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣"],
    duration: "45分钟/集",
    region: "中国大陆",
    isNew: false,
    isHot: true,
    isRecommended: true,
    updateInfo: "全30集",
  },
  {
    id: 12,
    title: "地球脉动第三季",
    englishTitle: "Planet Earth III",
    category: "documentary",
    genre: "自然 / 纪录",
    year: 2025,
    rating: 9.7,
    poster: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20wildlife%20and%20landscapes%2C%20vibrant%20natural%20colors%2C%20aerial%20view%20of%20earth%2C%20professional%20BBC%20documentary%20style%2C%20breathtaking%20natural%20beauty&width=600&height=840&seq=movie-12&orientation=portrait",
    description: "从海洋深处到最偏远的丛林，这部纪录片用前所未有的方式揭示了自然界最壮丽的奇观和动物们非凡的生存策略。",
    director: "BBC Studios",
    cast: ["大卫·爱登堡"],
    duration: "60分钟/集",
    region: "英国",
    isNew: true,
    isHot: false,
    isRecommended: true,
    updateInfo: "全8集",
  },
];

export const articles = [
  {
    id: 1,
    title: "流浪地球3幕后揭秘：中国科幻电影的工业革命",
    content: `
      <p>当《流浪地球3》的预告片在全网引发轰动之时，很少有人知道这部影片背后凝聚了多少中国电影人的心血与智慧。从2019年第一部上映至今，流浪地球系列已经走过了七个年头，而第三部无疑将系列推向了新的高度。</p>
      
      <h2>视觉特效的全面升级</h2>
      <p>《流浪地球3》在视觉效果上实现了飞跃式的进步。制作团队采用了全新的虚拟制片技术，将实景拍摄与数字特效完美融合。片中地球发动机的全景镜头，每一帧都经过数百小时的渲染和打磨。</p>
      
      <h2>演员阵容的强大加持</h2>
      <p>吴京、刘德华、李雪健三位实力派演员的加盟，为影片注入了强大的表演张力。刘德华饰演的角色更是为整个故事增添了一抹温情与深度。</p>
      
      <h2>中国科幻的国际视野</h2>
      <p>与前作相比，《流浪地球3》在叙事上有了更大的格局。影片不仅仅局限于中国视角，而是从全人类的命运出发，展现了更加宏大的宇宙观和价值观。这种叙事方式让影片在国际市场上也获得了广泛认可。</p>
      
      <h2>工业化制作体系的成熟</h2>
      <p>《流浪地球3》的制作标志着中国科幻电影工业化体系的日趋成熟。从前期策划、美术设计到后期制作，每一个环节都建立了标准化的流程，为中国科幻电影的未来发展奠定了坚实基础。</p>
    `,
    summary: "《流浪地球3》不仅是一部科幻巨制，更是中国电影工业化的重要里程碑。本文将带你深入了解影片幕后的制作故事。",
    date: "2026-07-28",
    author: "大师兄影视编辑部",
    category: "movie",
    views: 158200,
    relatedIds: [2, 6, 9],
    poster: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20Chinese%20sci-fi%20movie%20production%20with%20film%20crew%20and%20equipment%2C%20professional%20film%20set%2C%20cinematic%20lighting%2C%20industrial%20aesthetic%2C%20modern%20film%20studio%20environment&width=1200&height=600&seq=article-01&orientation=landscape",
  },
  {
    id: 2,
    title: "封神第二部票房突破40亿，中国神话电影迎来高光时刻",
    content: `
      <p>《封神第二部》自上映以来，票房一路高歌猛进，截至发稿时已突破40亿元人民币，成为中国影史票房榜上的又一力作。这部改编自中国古典神话的小说《封神演义》的影片，用现代化的电影语言重新诠释了古老的传说。</p>
      
      <h2>票房奇迹的背后</h2>
      <p>《封神第二部》的成功并非偶然。从第一部的口碑积累，到第二部的全面爆发，制作团队在每一个环节都追求极致。影片中宏大的战争场面、精美的服化道设计、以及演员们的精湛表演，共同成就了这部现象级作品。</p>
      
      <h2>中国神话宇宙的构建</h2>
      <p>乌尔善导演曾表示，封神系列将打造一个完整的中国神话电影宇宙。从商周更迭到封神演义，这个庞大的故事体系为中国电影提供了取之不尽的创作素材。</p>
      
      <h2>文化自信的体现</h2>
      <p>《封神第二部》的成功，不仅仅是商业上的胜利，更是中国文化自信的体现。影片将中国传统美学与现代电影技术完美结合，向世界展示了中国文化的独特魅力。</p>
    `,
    summary: "《封神第二部》票房突破40亿，中国神话电影正在用实力证明自己的市场价值和艺术魅力。",
    date: "2026-07-25",
    author: "大师兄影视编辑部",
    category: "movie",
    views: 235600,
    relatedIds: [1, 3, 11],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20epic%20battle%20scene%20with%20thousands%20of%20ancient%20soldiers%2C%20dramatic%20sky%2C%20golden%20and%20crimson%20tones%2C%20cinematic%20wide%20shot%2C%20movie%20production%20still&width=1200&height=600&seq=article-02&orientation=landscape",
  },
  {
    id: 3,
    title: "哪吒系列动画电影：国产动画的崛起之路",
    content: `
      <p>从《哪吒之魔童降世》到《哪吒之魔童闹海》，哪吒系列已经成为中国动画电影的一面旗帜。这个源自中国传统神话的少年英雄，在当代动画人的手中焕发出了全新的生命力。</p>
      
      <h2>技术突破</h2>
      <p>《哪吒之魔童闹海》在动画技术上实现了多项突破。全新的面部表情系统让角色的情感表达更加细腻，流体模拟技术的升级让海战场面达到国际一流水准。</p>
      
      <h2>故事创新</h2>
      <p>导演饺子在传统故事的基础上进行了大胆创新，赋予了哪吒更加立体的人物性格。"我命由我不由天"的精神内核，引发了当代观众的强烈共鸣。</p>
      
      <h2>产业影响</h2>
      <p>哪吒系列的成功，极大地提振了中国动画产业的信心。越来越多的资本和人才涌入这一领域，中国动画正在迎来最好的时代。</p>
    `,
    summary: "从魔童降世到魔童闹海，哪吒系列见证了中国动画电影从崛起到领跑的完整历程。",
    date: "2026-07-20",
    author: "大师兄影视编辑部",
    category: "anime",
    views: 189400,
    relatedIds: [4, 8, 12],
    poster: "https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20creating%20animated%20film%2C%20digital%20drawing%20tablets%2C%20colorful%20character%20designs%20on%20screens%2C%20creative%20workspace%2C%20modern%20animation%20production%20environment&width=1200&height=600&seq=article-03&orientation=landscape",
  },
];